import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'

const resource = '/pan';
export default {
  verifyPan(panVerificationRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/verify`, panVerificationRequest);
  },

  getPanOcrData(file) {
    creditEngineRepository.setContentType("multipart/form-data");
    const formData = new FormData();
    formData.append('file',file)
    return CreditEngineRepository.post("/data/pan", formData);
  }

}
